import { defineStore } from "pinia";
import {
  collection,
  query,
  getFirestore,
  getDocs,
  setDoc,
  doc
} from "firebase/firestore";
import { userUserStore } from "../stores/user";
import { UsuarioRol, usuarioRolConverter } from "@fixeduy/restaurantestypes";

export const useUsuarioRolesStore = defineStore({
  id: "usuariosRoles",
  persist: true,
  state: () => {
    return {
      _roles: [] as UsuarioRol[],
      _cargando: false
    };
  },
  getters: {
    cargando(): boolean {
      return this.cargando;
    },
    roles(): UsuarioRol[] {
      return this._roles;
    }
  },
  actions: {
    async getRolesFromFirestore() {
      this._cargando = true;
      const db = getFirestore();
      const userStore = userUserStore();
      const collectionRoute = `empresas/${userStore.empresa?.id}/usuarios-roles/`;

      const querySnapshot = await getDocs(
        query(collection(db, collectionRoute)).withConverter(
          usuarioRolConverter
        )
      );
      this._roles = [];
      querySnapshot.forEach(doc => {
        this._roles.push(doc.data());
      });
      this._roles.sort((a, b) => (b.rol > a.rol ? -1 : 1));
      this._cargando = false;
    },
    async crearRol(rol: UsuarioRol) {
      const db = getFirestore();
      const userStore = userUserStore();
      const collectionRoute = `empresas/${userStore.empresa?.id}/usuarios-roles/`;

      const docRef = doc(collection(db, collectionRoute)).withConverter(
        usuarioRolConverter
      );
      rol.id = docRef.id;
      setDoc(docRef, rol);

      this._roles.push(rol);
      this._roles.sort((a, b) => (b.rol > a.rol ? -1 : 1));

      return true;
    },
    getRolById(rolId: string): UsuarioRol | null {
      for (let i = 0; i < this._roles.length; i++) {
        if (this._roles[i].id == rolId) {
          return this._roles[i];
        }
      }
      return null;
    }
  }
});
